function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m277.938 0h-58.876c-23.059 0-40.279 21.137-35.726 43.742 6.586 32.701 18.439 51.306 18.439 51.306l46.72 32.719 46.732-32.719s11.853-18.605 18.439-51.306c4.551-22.605-12.669-43.742-35.728-43.742z",
  fill: "#f0ac99"
}), /*#__PURE__*/React.createElement("path", {
  d: "m231.774 95.048s-11.853-18.604-18.439-51.306c-4.552-22.605 12.668-43.742 35.727-43.742h-30c-23.059 0-40.279 21.137-35.726 43.742 6.586 32.701 18.439 51.306 18.439 51.306z",
  fill: "#e7886e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m299.545 211.84v-75.744h-102.09v75.744c0 5.539-5.207 9.562-10.583 8.231-116.891-28.945-225.295 124.987 55.384 275.363 3.897 2.088 8.592 2.088 12.489 0 280.678-150.376 172.275-304.308 55.384-275.364-5.377 1.332-10.584-2.692-10.584-8.23z",
  fill: "#ff748f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m116.615 309.554c2.78 11.603 8.726 24.21 17.64 37.117 21.263 30.787 55.068 57.784 88.057 79.128 15.925 10.303 36.45 10.303 52.376 0 32.986-21.342 66.786-48.337 88.047-79.124 8.914-12.908 14.859-25.516 17.639-37.12-173.594 32.126-169.388-39.813-263.759-.001z",
  fill: "#ffbdd7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m299.545 190.32v-54.225h-102.09v54.226c1.429.098 2.866.166 4.319.166h93.44c1.457 0 2.898-.068 4.331-.167z",
  fill: "#f9496e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m295.214 95.048h-93.44c-18.07 0-32.719 14.649-32.719 32.719 0 18.07 14.649 32.719 32.719 32.719h93.44c18.07 0 32.719-14.649 32.719-32.719 0-18.07-14.648-32.719-32.719-32.719z",
  fill: "#ff748f"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m186.095 366.398c-4.142 0-7.5-3.358-7.5-7.5v-11.992c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v11.992c0 4.142-3.358 7.5-7.5 7.5z",
  fill: "#423e4f"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m310.905 366.398c-4.142 0-7.5-3.358-7.5-7.5v-11.992c0-4.142 3.358-7.5 7.5-7.5s7.5 3.358 7.5 7.5v11.992c0 4.142-3.358 7.5-7.5 7.5z",
  fill: "#423e4f"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m248.5 373.536c-8.473 0-16.531-3.67-22.107-10.068-2.721-3.123-2.396-7.86.727-10.582 3.123-2.721 7.86-2.396 10.582.727 2.727 3.129 6.662 4.923 10.798 4.923s8.072-1.794 10.798-4.923c2.721-3.123 7.458-3.448 10.582-.727 3.123 2.721 3.448 7.459.727 10.582-5.576 6.398-13.634 10.068-22.107 10.068z",
  fill: "#423e4f"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 309.557,
  cy: 271.906,
  fill: "#ffbdd7",
  r: 19.326
}), /*#__PURE__*/React.createElement("circle", {
  cx: 244.384,
  cy: 225.013,
  fill: "#ffbdd7",
  r: 17.571
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.31 413.6c-40.72-45.159-54.458-90.264-59.047-113.577-8.555 1.956-17.969 5.026-28.648 9.531 2.781 11.603 8.726 24.21 17.64 37.117 17.396 25.187 43.186 47.836 70.055 66.929z",
  fill: "#ff97c0"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 497 497",
  height: 512,
  viewBox: "0 0 497 497",
  width: 512
}, props), _ref);

export default __webpack_public_path__ + "static/media/savePotion.4c8ca699.svg";
export { SvgComponent as ReactComponent };